import { useStore } from '../store';

export const setNotice = (type: string | null, message?: string) => {
  useStore.setState({ notice: { type, message } });
}
